// Losse constanten die zowel de configurator-hook als de winkelwagen-prijsberekening nodig
// hebben. In een eigen bestand zodat cart-pricing.ts (geladen op élke pagina via CartFlyout)
// niet de hele useConfigurator.ts-hook (NEN-check, catalogus-overrides, kleurenlijst, ...)
// hoeft mee te bundelen voor één getal.
export const SPELING_MM = 4;
